import React, { Component } from 'react';
import { Header, Form, Segment } from 'semantic-ui-react';

class SignUp extends Component {
  render() {
    const { tittel, knappTekst, knappTekstStotte, history } = this.props;
    return (
      <Segment basic textAlign="center">
        <Header as="h1">
          <span dangerouslySetInnerHTML={{ __html: tittel }} />
        </Header>
        <Form>
          <Form.Button
            onClick={this.openInnmelding(history)}
            color="yellow"
            size="big"
          >
            {knappTekst}
          </Form.Button>
          <Form.Button onClick={this.openStotte} size="large">
            {knappTekstStotte}
          </Form.Button>
        </Form>
      </Segment>
    );
  }

  openStotte() {
    window.location.href = 'https://hanenno.wufoo.eu/forms/stattemedlemskap/';
  }

  openInnmelding(history) {
    return () => {
      history.push('/innmelding');
    };
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/LandingPage/SignUp.js